/** Hand a blob to the browser as a file download.
 *
 * Copied out of `useExportEntity` rather than written fresh: the anchor has to
 * be in the document when it is clicked, and the object URL has to outlive the
 * click, or the download silently does nothing in some browsers. Both details
 * are easy to leave out — this file exists so they are written once.
 */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};
